import React from "react";
import Table, { TableRow, TableCell } from "@amzn/meridian/table";
import Checkbox from "@amzn/meridian/checkbox";
import Button from "@amzn/meridian/button";
import Text from "@amzn/meridian/text";
import Icon from "@amzn/meridian/icon";
import EyeToken from "@amzn/meridian-tokens/base/icon/view";
import LoaderBox from "../../../loader/LoaderBox";
import { ImageTableProps } from "./types";

export const ImageTable: React.FC<ImageTableProps> = ({
    images,
    selected,
    imageUrls,
    onChangeRow,
    handleExpandImage,
}) => {
    return (
        <Table showDividers={true}>
            {images.map(image => (
                <TableRow key={image.canopyS3Key}>
                    <TableCell>
                        <Checkbox
                            checked={selected[image.canopyS3Key] || false}
                            onChange={onChangeRow(image.canopyS3Key)}
                        />
                    </TableCell>
                    <TableCell>
                        <Text>{image.fileName}</Text>
                        <Text color="secondary">{image.type}</Text>
                    </TableCell>
                    <TableCell alignmentHorizontal={"end"}>
                        {imageUrls[image.canopyS3Key] ? (
                            <div className="image-container">
                                <Button
                                    type={"icon"}
                                    onClick={() => handleExpandImage(imageUrls[image.canopyS3Key])}
                                >
                                    <Icon tokens={EyeToken} />
                                </Button>
                            </div>
                        ) : (
                            <LoaderBox height={"fit"} loadingText={"Loading Image"} />
                        )}
                    </TableCell>
                </TableRow>
            ))}
        </Table>
    );
};
